import type { HeaderAction, NavItem, UserMenuItem } from "@repo/dashboard-core";

// Sidebar: My Files, AI Chat, PDF Tools, File Tools, CV Maker, Forms, Document
export const navItems: NavItem[] = [
  { icon: "folder", labelKey: "nav.my-files", href: "/" },
  { icon: "chatBot", labelKey: "nav.ai-chat", href: "/ai-chat" },
  { icon: "wrench", labelKey: "nav.tools", href: "/tools" },
  { icon: "folder", labelKey: "nav.file-tools", href: "/file-tools" },
  { icon: "user", labelKey: "nav.cv-maker", href: "/cv-maker" },
  { icon: "clipboard", labelKey: "nav.forms", href: "/forms" },
  { icon: "fileText", labelKey: "nav.document", href: "/document" },
];

// Header action buttons (top bar) — same pattern as tu
export const headerActions: HeaderAction[] = [
  { icon: "messages", href: "/messages", labelKey: "nav.messages" },
  { icon: "questionCircle", href: "/faq", labelKey: "nav.faq" },
  { icon: "phone", href: "/contact", labelKey: "nav.contact" },
];

// User dropdown: Profile, How it works, Logout
// User dropdown — matches tu pattern
export const userMenuItems: UserMenuItem[] = [
  { icon: "user", labelKey: "user-menu.my-profile", href: "/profile" },
  { icon: "signOut", labelKey: "user-menu.log-out", danger: true },
];
